import axiosInstance from '../axiosConfig';
import { Token } from '../components/EditToken';
import dayjs from 'dayjs';

const API_URL = '/api/tokens';

function serializeToken(token: Token): any {
    const result : any = { ...token };

    if (result.dueDate) {
        result.dueDate = dayjs(token.dueDate).format('YYYY-MM-DD');
    };

    return result;
}

export const TokenService = {
    async fetchTokens(): Promise<Token[]> {
        const response = await axiosInstance.get<Token[]>(API_URL);
        return response.data.map(token => ({
            ...token,
            createdAt: new Date(token.createdAt),
            exportedAt: token.exportedAt ? new Date(token.exportedAt) : undefined,
            filledAt: token.filledAt ? new Date(token.filledAt) : undefined,
            emailSentAt: token.emailSentAt ? new Date(token.emailSentAt) : undefined,
            dueDate: token.dueDate ? new Date(token.dueDate) : undefined,
            fileUploaded: !!(token as any).fileUploaded
        }));
    },
    async createToken(token: Token): Promise<Token> {
        const response = await axiosInstance.post<Token>(API_URL, serializeToken(token));
        return response.data;
    },
    async editToken(id: string, token: Token): Promise<Token> {
        const response = await axiosInstance.put<Token>(`${API_URL}/${id}`, serializeToken(token));
        return response.data;
    },
    async exportTokens(tokenIds: string[]): Promise<any> {
        const params = new URLSearchParams();
        tokenIds.forEach(id => params.append('id', id));
        const response = await axiosInstance.get(`${API_URL}?${params.toString()}`, {
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
        });
        return response;
    },
    async sendEmails(tokenIds: string[]): Promise<any> {
        const response = await axiosInstance.post(`${API_URL}/send-email`, { tokenIds });
        return response.data;
    },
    async uploadResultFile(tokenId: string, file: File): Promise<any> {
        const response = await axiosInstance.post(
            `${API_URL}/${tokenId}/result-file`,
            file,
            {
                headers: {
                    'Content-Type': file.type || 'application/pdf',
                },
            }
        );
        return response.data;
    }
    ,
    async downloadResultFile(tokenId: string): Promise<Blob> {
        const response = await axiosInstance.get(`${API_URL}/${tokenId}/result-file`, {
            responseType: 'blob'
        });
        return response.data as Blob;
    }
};